"use client";

import { useEffect } from "react";
import { Providers } from "@microsoft/mgt-element";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import { msalInstance } from "./authConfig";

export default function MgtProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      msalInstance &&
      !Providers.globalProvider
    ) {
      Providers.globalProvider = new Msal2Provider({
        publicClientApplication: msalInstance as any,
      });
    }
  }, []);

  return <>{children}</>;
}
